import { cn } from '@ifixit/ui/lib/utils';
import { FaIcon } from '@ifixit/ui/components/icon';
import { ComponentProps, ReactNode, Ref } from 'react';

export type FlagBadgeStyle = {
   badgeClass: string;
   iconClass?: string;
};

export function FlagBadge({
   ref,
   icon,
   iconStyle = 'regular',
   iconClass,
   imageSrc,
   badgeClass,
   className,
   children,
   ...rest
}: {
   icon?: string;
   iconStyle?: 'solid' | 'regular';
   iconClass?: string;
   imageSrc?: string;
   badgeClass: string;
   children?: ReactNode;
   ref?: Ref<HTMLDivElement>;
} & ComponentProps<'div'>) {
   return (
      <div
         className={cn(
            'flex items-center px-1.5 py-1 leading-[18px] rounded border font-medium text-[13px] sm:text-sm whitespace-nowrap',
            badgeClass,
            className
         )}
         tabIndex={0}
         ref={ref}
         {...rest}
      >
         {icon && (
            <FaIcon
               name={icon}
               style={iconStyle}
               className={cn('size-4 sm:size-5 mr-1', iconClass)}
            />
         )}
         {imageSrc && <img src={imageSrc} className="flex self-center size-4 sm:size-5 mr-1" />}
         {children}
      </div>
   );
}
